(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[4961],{

/***/ 54961:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Reels": function() { return /* reexport */ Reels; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(69396);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(7297);
// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 2 modules
var styled_components_browser_esm = __webpack_require__(50066);
;// CONCATENATED MODULE: ./src/components/DesignSystem/Widgets2.0/ListPresentation/components/Reels/ReelsStyledModules.ts

function _templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  max-width: 100vw;\n  position: ",
        ";\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  height: ",
        ";\n  max-height: 100%;\n  width: 100%;\n  z-index: 9999;\n  overflow: hidden;\n  overscroll-behavior: none;\n  background-color: #000000;\n\n  @media screen and (min-width: 769px) {\n    background-color: transparent;\n    position: relative;\n    /* max-width: 728px; */\n    height: 100vh;\n    display: flex;\n    align-items: center;\n    padding: 0 40px;\n    margin: 0 auto;\n  }\n\n  @media screen and (min-width: 968px) {\n    /* max-width: 840px; */\n  }\n\n  @media screen and (min-width: 1286px) {\n    max-width: 1200px;\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  width: 100%;\n  display: flex;\n  flex-direction: column;\n  list-style: none;\n  overflow-y: auto;\n  height: ",
        ";\n\n  /* contain -> prevent accidentally going back or triggering other swipe events */\n  overscroll-behavior: none;\n\n  /* hide scroll bar */\n  scrollbar-width: none;\n  -ms-overflow-style: none;\n\n  /* momentum scroll on iOS */\n  -webkit-overflow-scrolling: touch;\n\n  /* disbable vertical scroll for touch */\n  touch-action: pan-y pan-x;\n\n  /* scroll snapping */\n  scroll-snap-type: y mandatory;\n\n  @media screen and (min-width: 769px) {\n    touch-action: none;\n    width: 540px;\n    max-width: 700px;\n    gap: ",
        "px;\n    scroll-snap-type: x mandatory;\n    padding: 0 calc(250px - 45px); /** Removed half of the gap */\n    margin: 0 auto;\n    flex-direction: row;\n    align-items: center;\n    overflow-x: scroll;\n    overflow-y: hidden;\n    max-height: 100vh;\n  }\n\n  @media screen and (min-width: 968px) {\n    width: 700px;\n    max-width: 800px;\n    gap: ",
        "px;\n    padding: 0 calc(350px - 45px); /** Removed half of the gap */\n    margin: 0 auto;\n  }\n\n  @media screen and (min-width: 1068px) {\n    width: unset;\n    max-width: 1000px;\n    padding: 0 calc(360px - 45px); /** Removed half of the gap */\n  }\n\n  /* @media screen and (min-width: 968px) {\n    width: 800px;\n    padding: 0 calc(400px - 45px);\n  }\n\n  @media screen and (min-width: 1024px) {\n    width: 900px;\n    padding: 0 calc(450px - 45px);\n  }\n\n  @media screen and (min-width: 1280px) {\n    width: 1200px;\n    padding: 0 calc(600px - 45px);\n  } */\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  overscroll-behavior: none;\n  width: 100vw;\n  height: ",
        ";\n  display: flex;\n  flex-direction: column;\n  flex-shrink: 0;\n  background-color: #000000;\n  transition: scale 500ms linear;\n  position: relative;\n\n  /* scroll snapping */\n  scroll-snap-align: center;\n\n  /* maybe this will work in the future \uD83E\uDD37‍♂️ */\n  scroll-snap-stop: always;\n\n  @media screen and (min-width: 768px) {\n    overflow: hidden;\n    width: ",
        ";\n    height: ",
        ";\n    border-radius: ",
        ";\n\n    /* scroll snapping */\n    scroll-snap-align: center;\n  }\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}

var ReelsViewportWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "ReelsViewportWrapper",
    componentId: "sc-f8c3c0b3-0"
})(_templateObject(), function(props) {
    return props.isMobile ? "fixed" : "unset";
}, function(props) {
    return props.isMobile && props.mobileHeight ? "".concat(props.mobileHeight, "px") : "100%";
});
var ReelsListWrapper = styled_components_browser_esm/* default.ul.withConfig */.ZP.ul.withConfig({
    displayName: "ReelsListWrapper",
    componentId: "sc-f8c3c0b3-1"
})(_templateObject1(), function(props) {
    return props.mobileHeight ? "".concat(props.mobileHeight, "px") : "100%";
}, function(props) {
    return props.columnGap;
}, function(props) {
    return props.columnGap;
});
/* height: ${(props) => `${props.mobileHeight}px` || '100vh'}; */ var ReelItem = styled_components_browser_esm/* default.li.withConfig */.ZP.li.withConfig({
    displayName: "ReelItem",
    componentId: "sc-f8c3c0b3-2"
})(_templateObject2(), function(props) {
    return "".concat(props.mobileHeight, "px") || 0;
}, function(props) {
    return "".concat(props.width, "px") || 0;
}, function(props) {
    return "".concat(props.height, "px") || 0;
}, function(props) {
    return props.borderRadius;
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_sliced_to_array.mjs
var _sliced_to_array = __webpack_require__(10253);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_to_consumable_array.mjs + 2 modules
var _to_consumable_array = __webpack_require__(29815);
// EXTERNAL MODULE: ./node_modules/classnames/index.js
var classnames = __webpack_require__(93967);
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);
// EXTERNAL MODULE: ./src/components/WidgetMaker/WidgetDnD/WIdgetPropertiesBasic/components/Button/index.tsx + 1 modules
var Button = __webpack_require__(46976);
// EXTERNAL MODULE: ./src/config/paymentLinks.js
var paymentLinks = __webpack_require__(96668);
// EXTERNAL MODULE: ./src/utils/formatPricing.ts
var formatPricing = __webpack_require__(54065);
// EXTERNAL MODULE: ./src/components/DesignSystem/AtomicDesignsUtilities/ContentButtonAnimationStyle.module.scss
var ContentButtonAnimationStyle_module = __webpack_require__(36508);
var ContentButtonAnimationStyle_module_default = /*#__PURE__*/__webpack_require__.n(ContentButtonAnimationStyle_module);
// EXTERNAL MODULE: ./src/utils/getDiscountPercentage.js
var getDiscountPercentage = __webpack_require__(53716);
// EXTERNAL MODULE: ./src/components/DesignSystem/Widgets2.0/Carousel/utils.tsx
var utils = __webpack_require__(58619);
// EXTERNAL MODULE: ./src/components/WidgetMaker/utils/buttonConstant.ts
var buttonConstant = __webpack_require__(91850);
// EXTERNAL MODULE: ./src/hooks/useItemClick.js + 1 modules
var useItemClick = __webpack_require__(80058);
// EXTERNAL MODULE: ./src/components/DesignSystem/Widgets2.0/ListPresentation/components/utils.ts
var components_utils = __webpack_require__(3310);
// EXTERNAL MODULE: ./src/components/DesignSystem/ModernTheme/utils/common.js + 9 modules
var common = __webpack_require__(20901);
// EXTERNAL MODULE: ./src/utils/deviceWidth.js
var deviceWidth = __webpack_require__(86812);
;// CONCATENATED MODULE: ./src/components/DesignSystem/Widgets2.0/ListPresentation/components/Reels/data.ts
var REEL_CONFIGS = {
    FOCUSED_DIMENSIONS: {
        width: 317,
        height: 564
    },
    UNFOCUSED_DIMENSIONS: {
        width: 224,
        height: 400
    },
    COLUMN_GAP_DESKTOP_MODAL: 90
};

// EXTERNAL MODULE: ./src/components/DesignSystem/AtomicDesignsUtilities/ContentAnimationStyles.module.scss
var ContentAnimationStyles_module = __webpack_require__(89429);
var ContentAnimationStyles_module_default = /*#__PURE__*/__webpack_require__.n(ContentAnimationStyles_module);
// EXTERNAL MODULE: ./src/components/DesignSystem/Widgets2.0/CardFrameCollection/utils.ts
var CardFrameCollection_utils = __webpack_require__(90331);
// EXTERNAL MODULE: ./src/components/WidgetMaker/WidgetDnD/GlobalCfeLoader.tsx
var GlobalCfeLoader = __webpack_require__(79220);
// EXTERNAL MODULE: ./src/context/WidgetDndContext/index.ts
var WidgetDndContext = __webpack_require__(74151);
// EXTERNAL MODULE: ./src/components/DesignSystem/Widgets2.0/ListPresentation/hooks/useLoadVisibleReel.ts
var useLoadVisibleReel = __webpack_require__(52999);
;// CONCATENATED MODULE: ./src/components/DesignSystem/Widgets2.0/ListPresentation/components/Reels/ReelsMetaData.tsx
























var ReelsVideoSection = /*#__PURE__*/ (0,react.forwardRef)(function Reels(props, videoRef) {
    var playVideo = function playVideo() {
        var ref;
        (ref = videoRef[reelIndex]) === null || ref === void 0 ? void 0 : ref.play();
    };
    var pauseVideo = function pauseVideo() {
        var ref;
        (ref = videoRef[reelIndex]) === null || ref === void 0 ? void 0 : ref.pause();
    };
    var resetVideo = function resetVideo() {
        if (videoRef[reelIndex]) videoRef[reelIndex].currentTime = 0;
    };
    var muteStatus = function muteStatus() {
        if (fromModal && isModalOpen && isThisReelFocused) return shouldMuteVideo;
        return true;
    };
    var ref, ref1, ref2;
    var reelItem = props.reelItem, reelIndex = props.reelIndex, onClick = props.onClick, _fromModal = props.fromModal, fromModal = _fromModal === void 0 ? false : _fromModal, isModalOpen = props.isModalOpen, _customStyle = props.customStyle, customStyle = _customStyle === void 0 ? {} : _customStyle, modalScrolled = props.modalScrolled, _scrollContainerRef = props.scrollContainerRef, scrollContainerRef = _scrollContainerRef === void 0 ? 0 : _scrollContainerRef, callback = props.callback, isMobile = props.isMobile, oneGridCellGeometry = props.oneGridCellGeometry, isBuilder = props.isBuilder, isThisReelFocused = props.isThisReelFocused, cardFrameConfig = props.cardFrameConfig, isLastReel = props.isLastReel, shouldMuteVideo = props.shouldMuteVideo, setShouldMuteVideo = props.setShouldMuteVideo, _isMobileFocusPlayEnabled = props.isMobileFocusPlayEnabled, isMobileFocusPlayEnabled = _isMobileFocusPlayEnabled === void 0 ? false : _isMobileFocusPlayEnabled;
    var ref3 = (0,WidgetDndContext/* useWidgetDndContextData */.KX)(), globalStyle = ref3.widgetContextState.globalStyle;
    var mappedProduct = reelItem === null || reelItem === void 0 ? void 0 : (ref = reelItem.mappedProduct) === null || ref === void 0 ? void 0 : ref[0];
    var containerWidth = !isBuilder ? scrollContainerRef === null || scrollContainerRef === void 0 ? void 0 : scrollContainerRef.clientWidth : deviceWidth/* deviceWidth */.o;
    var modalAutoPlayConfig = fromModal ? isThisReelFocused : false;
    var layoutAutoPlayconfig = {
        all: (cardFrameConfig === null || cardFrameConfig === void 0 ? void 0 : cardFrameConfig.reelDesktopBehaviour) === "autoPlayAll",
        sequential: (cardFrameConfig === null || cardFrameConfig === void 0 ? void 0 : cardFrameConfig.reelDesktopBehaviour) === "autoplayOne",
        onHover: (cardFrameConfig === null || cardFrameConfig === void 0 ? void 0 : cardFrameConfig.reelDesktopBehaviour) === "playOnHover"
    };
    var ref4 = (0,react.useState)({
        play: false
    }), autoPlayConfig = ref4[0], setAutoPlayConfig = ref4[1];
    var ref5 = (0,react.useState)(0), // loopNumber
    setLoopNumber = ref5[1];
    var ref6 = (0,react.useState)(false), loadVideo = ref6[0], setLoadVideo = ref6[1];
    var ref7 = (0,react.useState)(false), isVideoDownloaded = ref7[0], setIsVideoDownloaded = ref7[1];
    (0,useLoadVisibleReel/* useLoadVisibleReel */.c)({
        videoRef: videoRef,
        reelIndex: reelIndex,
        setLoadVideo: setLoadVideo,
        loadVideo: loadVideo
    });
    (0,react.useEffect)(function() {
        if (fromModal && !isThisReelFocused) {
            setLoopNumber(0);
        }
    }, [
        isThisReelFocused,
        fromModal
    ]);
    // useEffect(() => {
    //   if (fromModal && loopNumber >= 1) {
    //     callback?.({ currentSelectedReelIdx: isLastReel ? 0 : reelIndex + 1 });
    //   }
    // }, [loopNumber, fromModal, isLastReel, reelIndex]);
    // For desktop this sets the current chosen index
    (0,react.useEffect)(function() {
        if (fromModal) {
            if (!isMobile) {
                var ref;
                var elementRect = (ref = videoRef[reelIndex]) === null || ref === void 0 ? void 0 : ref.getBoundingClientRect();
                var elementPositionFromLeft = isThisReelFocused ? elementRect.left - 20 : elementRect.left - 20;
                if (Math.floor(elementPositionFromLeft) === Math.floor(containerWidth / 2) || Math.floor(elementPositionFromLeft) === Math.ceil(containerWidth / 2) || Math.ceil(elementPositionFromLeft) === Math.floor(containerWidth / 2) || Math.ceil(elementPositionFromLeft) === Math.ceil(containerWidth / 2)) {
                    callback === null || callback === void 0 ? void 0 : callback({
                        currentSelectedReelIdx: reelIndex
                    });
                }
            }
        }
    }, [
        modalScrolled
    ]);
    (0,react.useEffect)(function() {
        if (fromModal && isModalOpen) {
            if (isThisReelFocused) {
                if (isMobile) {
                    scrollContainerRef === null || scrollContainerRef === void 0 ? void 0 : scrollContainerRef.scrollTo({
                        top: scrollContainerRef.clientHeight * reelIndex,
                        behavior: "instant"
                    });
                } else {
                    scrollContainerRef === null || scrollContainerRef === void 0 ? void 0 : scrollContainerRef.scrollTo({
                        left: (REEL_CONFIGS.UNFOCUSED_DIMENSIONS.width + REEL_CONFIGS.COLUMN_GAP_DESKTOP_MODAL) * reelIndex,
                        behavior: "instant"
                    });
                }
                playVideo();
            } else {
                pauseVideo();
            }
        }
        if (!fromModal) {
            if (isModalOpen) {
                pauseVideo();
            } else {
                playVideo();
            }
        }
    }, [
        isThisReelFocused,
        scrollContainerRef,
        isModalOpen,
        fromModal
    ]);
    (0,react.useEffect)(function() {
        if (fromModal) {
            setAutoPlayConfig({
                play: modalAutoPlayConfig
            });
        } else {
            setAutoPlayConfig({
                play: !isModalOpen ? layoutAutoPlayconfig.all || isMobile : false
            });
            if (!isModalOpen) {
                if (layoutAutoPlayconfig.all || isMobile) {
                    if (!isMobileFocusPlayEnabled) playVideo();
                    else isThisReelFocused ? playVideo() : pauseVideo();
                }
            } else {
                isThisReelFocused ? playVideo() : pauseVideo();
            }
            if (layoutAutoPlayconfig.onHover && !isMobile) {
                resetVideo();
                pauseVideo();
            }
        }
    }, [
        isModalOpen, 
    ].concat((0,_to_consumable_array/* default */.Z)(fromModal ? [
        modalAutoPlayConfig
    ] : [
        isThisReelFocused,
        layoutAutoPlayconfig.all,
        layoutAutoPlayconfig.onHover,
        isMobile,
        isMobileFocusPlayEnabled, 
    ])));
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: classnames_default()("tw-relative tw-flex-shrink-0 tw-overflow-hidden", !isThisReelFocused && "tw-cursor-pointer", !isThisReelFocused && isModalOpen && "tw-opacity-70"),
        style: (0,_object_spread/* default */.Z)({
            width: "".concat(oneGridCellGeometry === null || oneGridCellGeometry === void 0 ? void 0 : oneGridCellGeometry.width, "px"),
            height: "".concat(oneGridCellGeometry === null || oneGridCellGeometry === void 0 ? void 0 : oneGridCellGeometry.height, "px")
        }, customStyle),
        onMouseEnter: function() {
            if (layoutAutoPlayconfig.onHover && !fromModal) {
                playVideo();
            }
        },
        onMouseLeave: function() {
            if (layoutAutoPlayconfig.onHover && !fromModal) {
                resetVideo();
                pauseVideo();
            }
        },
        onClick: function() {
            if (fromModal && !autoPlayConfig.play) {
                setAutoPlayConfig({
                    play: !autoPlayConfig.play
                });
            // !shouldPlayVideo ? videoRef[reelIndex]?.play() : videoRef[reelIndex]?.pause();
            }
            onClick === null || onClick === void 0 ? void 0 : onClick();
        },
        children: [
            !modalAutoPlayConfig && !!reelItem.thumbnail && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "tw-absolute tw-inset-0 tw-z-[1] tw-h-full tw-w-full",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                    src: reelItem.thumbnail,
                    className: "tw-h-full tw-w-full tw-object-cover"
                })
            }),
            !isVideoDownloaded && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "tw-absolute tw-left-1/2 tw-top-1/2 tw-z-[4] -tw-translate-x-1/2 -tw-translate-y-1/2",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(GlobalCfeLoader/* GlobalCfeLoader */.I, {
                    type: (globalStyle === null || globalStyle === void 0 ? void 0 : (ref1 = globalStyle.appLoader) === null || ref1 === void 0 ? void 0 : ref1.loaderId) || "ellipsis",
                    color: globalStyle === null || globalStyle === void 0 ? void 0 : (ref2 = globalStyle.appLoader) === null || ref2 === void 0 ? void 0 : ref2.color
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("video", {
                ref: function(node) {
                    return videoRef[reelIndex] = node;
                },
                className: classnames_default()("tw-h-full tw-w-full tw-bg-black tw-object-cover", !isMobile || !isMobile && !fromModal && (cardFrameConfig === null || cardFrameConfig === void 0 ? void 0 : cardFrameConfig.hoverType) !== "zoomInCard" && (ContentAnimationStyles_module_default())[(0,CardFrameCollection_utils/* getCurrentClass */.WR)(cardFrameConfig === null || cardFrameConfig === void 0 ? void 0 : cardFrameConfig.hoverType)]),
                autoPlay: autoPlayConfig.play,
                loop: true,
                muted: muteStatus(),
                playsInline: true,
                onLoadedData: function() {
                    return setIsVideoDownloaded(true);
                },
                src: loadVideo ? reelItem.reelUrl : "",
                onSeeked: function() {
                    if (videoRef[reelIndex].currentTime === 0) {
                        setLoopNumber(function(c) {
                            return c + 1;
                        });
                    }
                },
                onTimeUpdate: function(e) {
                    if (!fromModal && !isModalOpen) {
                        if (e.currentTarget.currentTime >= 4) {
                            if (layoutAutoPlayconfig.all) {
                                resetVideo();
                                playVideo();
                            }
                            if (layoutAutoPlayconfig.sequential) {
                                callback === null || callback === void 0 ? void 0 : callback({
                                    currentSelectedReelIdx: isLastReel || !reelIndex ? reelIndex : reelIndex + 1
                                });
                            }
                        }
                    }
                }
            }),
            !!fromModal && isThisReelFocused && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                onClick: function() {
                    return setShouldMuteVideo(function(v) {
                        return !v;
                    });
                },
                className: classnames_default()("tw-pointer wb-sprite tw-absolute  tw-right-[12px] tw-z-[4]", !shouldMuteVideo ? "mute-lg" : "unmute-lg", mappedProduct ? "tw-bottom-[126px]" : "tw-bottom-[24px]")
            })
        ]
    });
});
function ReelsMetaData(param) {
    var reelItem = param.reelItem, isMobile = param.isMobile, _fromModal = param.fromModal, fromModal = _fromModal === void 0 ? false : _fromModal, cardFrameConfig = param.cardFrameConfig, _layoutName = param.layoutName, layoutName = _layoutName === void 0 ? "" : _layoutName, _addPadding = param.addPadding, addPadding = _addPadding === void 0 ? true : _addPadding, _listPresentationConfig = param.listPresentationConfig, listPresentationConfig = _listPresentationConfig === void 0 ? {} : _listPresentationConfig;
    var ref;
    var ref1 = (0,_sliced_to_array/* default */.Z)((0,useItemClick/* useItemClick */.M)(), 1), onItemClick = ref1[0];
    var mappedProduct = reelItem === null || reelItem === void 0 ? void 0 : (ref = reelItem.mappedProduct) === null || ref === void 0 ? void 0 : ref[0];
    var productNameSize = (0,components_utils/* getMappedproductsTextSize */.Im)(!isMobile ? cardFrameConfig === null || cardFrameConfig === void 0 ? void 0 : cardFrameConfig.productNameSize : cardFrameConfig === null || cardFrameConfig === void 0 ? void 0 : cardFrameConfig.productNameSizeMobile);
    var productPriceSize = (0,components_utils/* getMappedproductsTextSize */.Im)(!isMobile ? cardFrameConfig === null || cardFrameConfig === void 0 ? void 0 : cardFrameConfig.productPriceSize : cardFrameConfig === null || cardFrameConfig === void 0 ? void 0 : cardFrameConfig.productPriceSizeMobile);
    var productNameCasing = (0,components_utils/* getMappedProductCasing */.TI)(cardFrameConfig === null || cardFrameConfig === void 0 ? void 0 : cardFrameConfig.productNameTextCase);
    var productNameTextAlign = (0,components_utils/* getMappedProductTextAlign */.sz)(cardFrameConfig === null || cardFrameConfig === void 0 ? void 0 : cardFrameConfig.textAlign);
    var productNameThickness = (0,components_utils/* getMappedProductTextThickness */.aA)(cardFrameConfig === null || cardFrameConfig === void 0 ? void 0 : cardFrameConfig.productNameThincness);
    var productPriceThickness = (0,components_utils/* getMappedProductTextThickness */.aA)(cardFrameConfig === null || cardFrameConfig === void 0 ? void 0 : cardFrameConfig.productPriceThincness);
    var productPriceCasing = (0,components_utils/* getMappedProductCasing */.TI)(cardFrameConfig === null || cardFrameConfig === void 0 ? void 0 : cardFrameConfig.productPriceTextCase);
    var discount = (0,getDiscountPercentage/* getDiscountPercentage */.$)(mappedProduct === null || mappedProduct === void 0 ? void 0 : mappedProduct.price, mappedProduct === null || mappedProduct === void 0 ? void 0 : mappedProduct.discounted_price);
    var navigateToPdp = function() {
        return onItemClick(mappedProduct);
    };
    // For inside the modal reels
    if (fromModal && mappedProduct) {
        var ref2;
        return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: "tw-absolute tw-bottom-0 tw-left-0 tw-right-0 tw-px-[8px] tw-pb-[8px]",
            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "imgWrapperGlobalStyle globalImgStyleConsumer tw-flex tw-cursor-pointer tw-items-center tw-gap-[12px] tw-bg-white/[0.7] tw-p-[12px]",
                onClick: navigateToPdp,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "imgWrapperGlobalStyle globalImgStyleConsumer tw-h-[58px] tw-w-[58px] tw-flex-shrink-0 tw-border-[1.42px] tw-border-solid tw-border-[#ffffff]",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                            src: mappedProduct === null || mappedProduct === void 0 ? void 0 : mappedProduct.image_url,
                            className: "tw-object-cover"
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "tw-flex tw-flex-col",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                className: "tw-m-0 tw-line-clamp-2 tw-break-words tw-leading-[16px]",
                                style: (0,_object_spread/* default */.Z)({
                                    color: cardFrameConfig === null || cardFrameConfig === void 0 ? void 0 : cardFrameConfig.productNameColor
                                }, productNameSize, productNameThickness, productNameCasing),
                                children: mappedProduct === null || mappedProduct === void 0 ? void 0 : mappedProduct.name
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: classnames_default()("pricingSection tw-mt-[6px] tw-flex tw-flex-wrap tw-items-center tw-gap-x-[8px] tw-gap-y-[6px]"),
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        className: "pricingSection tw-flex tw-flex-wrap tw-items-end tw-gap-x-[4px] tw-gap-y-[6px]",
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                                                className: "tw-relative tw-m-0 tw-text-[11.4px] tw-leading-[0.88] tw-text-newBlack",
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                        children: paymentLinks/* CURRENT_CURRENCY_SYMBOL */.bZ
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                        children: (0,formatPricing/* formatPriceToINR */.e)(mappedProduct === null || mappedProduct === void 0 ? void 0 : mappedProduct.discounted_price)
                                                    })
                                                ]
                                            }),
                                            (mappedProduct === null || mappedProduct === void 0 ? void 0 : mappedProduct.discounted_price) !== (mappedProduct === null || mappedProduct === void 0 ? void 0 : mappedProduct.price) ? /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                                                // style={{ color: hexToRgba(overrideStyles?.textColor || config.productPriceColor,0.6), ...productActualPriceStyles.style,}}
                                                className: "tw-m-0 tw-text-[11.4px] tw-leading-[0.88] tw-text-newBlack/[0.6] tw-line-through",
                                                children: [
                                                    paymentLinks/* CURRENT_CURRENCY_SYMBOL */.bZ,
                                                    (0,formatPricing/* formatPriceToINR */.e)(mappedProduct === null || mappedProduct === void 0 ? void 0 : mappedProduct.price)
                                                ]
                                            }) : null
                                        ]
                                    }),
                                    !!discount && /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                        // style={{ background:config?.discountStyle !== 'text' && config?.backgroundColor,color: config?.textColor,}}
                                        className: classnames_default()("tw-m-0 tw-break-keep tw-px-[4px] tw-py-[2px] tw-text-center tw-text-[10.45px] tw-font-medium tw-leading-[1] ", "tw-bg-[#2CA861] tw-text-[#ffffff]"),
                                        children: "".concat(discount, "% OFF")
                                    })
                                ]
                            })
                        ]
                    }),
                    cardFrameConfig === null || cardFrameConfig === void 0 ? void 0 : (ref2 = cardFrameConfig.buttonConfig) === null || ref2 === void 0 ? void 0 : ref2.map(function(buttonData, btnIndex) {
                        var ref, ref1;
                        // const overlayTextStyles: any = getOverlayTextStyles(cardFrameConfig, buttonData);
                        var buttonVariant = (0,utils/* getButtonVariantsData */.Tk)(buttonData, false);
                        var selectedButtonType = buttonVariant[buttonData.type];
                        // const isBtnSolid = buttonData.type === BUTTON_TYPE.SOLID;
                        var isBtnTextual = buttonData.type === buttonConstant/* BUTTON_TYPE.TEXTUAL */.JB.TEXTUAL;
                        return /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                            btnType: buttonData.type,
                            onClick: navigateToPdp,
                            buttonData: buttonData,
                            selectedButtonData: selectedButtonType,
                            variant: selectedButtonType.variant,
                            disableHoverAnimation: isMobile,
                            className: classnames_default()("addToCtaButtonForProduct !tw-pointer-events-auto !tw-ml-auto !tw-max-h-[28px] !tw-min-w-[auto] tw-cursor-pointer !tw-font-medium", "!tw-w-max", !isBtnTextual ? "!tw-p-[6px]" : "!tw-p-0", // disable animations
                            !(buttonData === null || buttonData === void 0 ? void 0 : (ref = buttonData.buttonAnimationConfig) === null || ref === void 0 ? void 0 : ref.classKey) ? "[&_p]:before:!tw-hidden" : !isMobile && (ContentButtonAnimationStyle_module_default())[buttonData === null || buttonData === void 0 ? void 0 : (ref1 = buttonData.buttonAnimationConfig) === null || ref1 === void 0 ? void 0 : ref1.classKey]),
                            textWrapperClass: classnames_default()("!tw-w-full !tw-text-[12px] !tw-relative !tw-flex !tw-justify-center tw-break-keep tw-whitespace-nowrap"),
                            children: buttonData === null || buttonData === void 0 ? void 0 : buttonData.text
                        }, btnIndex);
                    })
                ]
            })
        });
    }
    // For widget layout reels
    switch(layoutName){
        case "layout2":
        case "layout3":
            return !!mappedProduct && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                onClick: navigateToPdp,
                className: classnames_default()("removeGlobalOverride imgWrapperGlobalStyle addBottomLeftGlobalRadius addBottomRightGlobalRadius globalImgStyleConsumer tw-flex tw-w-full tw-flex-grow tw-cursor-pointer tw-flex-col tw-items-center tw-bg-[#ffffff]", addPadding && (isMobile ? "tw-px-[10px] tw-pb-[11px]" : "tw-px-[14px] tw-pb-[15px]")),
                style: {
                    background: listPresentationConfig === null || listPresentationConfig === void 0 ? void 0 : listPresentationConfig.backgroundColor
                },
                children: [
                    layoutName !== "layout3" && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        onClick: navigateToPdp,
                        className: "imgWrapperGlobalStyle globalImgStyleConsumer tw-relative tw-top-[-40px] tw-h-[58px] tw-w-[58px] tw-cursor-pointer tw-border-[1.42px] tw-border-solid tw-border-[#ffffff]",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                            src: mappedProduct === null || mappedProduct === void 0 ? void 0 : mappedProduct.image_url,
                            className: "tw-object-cover"
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: classnames_default()("tw-flex tw-w-full tw-flex-col", (cardFrameConfig === null || cardFrameConfig === void 0 ? void 0 : cardFrameConfig.textAlign) === "center" && "tw-items-center", layoutName !== "layout3" ? "tw-mt-[-30px]" : "tw-mt-[16px]"),
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                className: "tw-m-0 tw-line-clamp-2 tw-leading-[20px]",
                                style: (0,_object_spread/* default */.Z)({
                                    color: cardFrameConfig === null || cardFrameConfig === void 0 ? void 0 : cardFrameConfig.productNameColor
                                }, productNameSize, productNameTextAlign, productNameThickness, productNameCasing),
                                children: mappedProduct === null || mappedProduct === void 0 ? void 0 : mappedProduct.name
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: classnames_default()("pricingSection tw-mt-[8px] tw-flex tw-flex-wrap tw-items-center tw-gap-x-[8px] tw-gap-y-[6px]", (cardFrameConfig === null || cardFrameConfig === void 0 ? void 0 : cardFrameConfig.textAlign) === "center" && "tw-justify-center"),
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        className: "pricingSection tw-flex tw-flex-wrap tw-items-end tw-gap-x-[4px] tw-gap-y-[6px]",
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                                                className: "tw-relative tw-bottom-[-0.5px] tw-m-0 tw-leading-[0.88]",
                                                style: (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
                                                    color: cardFrameConfig === null || cardFrameConfig === void 0 ? void 0 : cardFrameConfig.productPriceColor
                                                }, productPriceSize, productNameTextAlign, productPriceThickness, productPriceCasing), {
                                                    lineHeight: 0.88
                                                }),
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                        children: paymentLinks/* CURRENT_CURRENCY_SYMBOL */.bZ
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                        children: (0,formatPricing/* formatPriceToINR */.e)(mappedProduct === null || mappedProduct === void 0 ? void 0 : mappedProduct.discounted_price)
                                                    })
                                                ]
                                            }),
                                            (mappedProduct === null || mappedProduct === void 0 ? void 0 : mappedProduct.discounted_price) !== (mappedProduct === null || mappedProduct === void 0 ? void 0 : mappedProduct.price) ? /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                                                style: (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
                                                    color: (0,common/* hexToRgba */.a7)(cardFrameConfig === null || cardFrameConfig === void 0 ? void 0 : cardFrameConfig.productPriceColor, 0.6)
                                                }, productPriceSize, productNameTextAlign, productPriceThickness), {
                                                    lineHeight: 0.88
                                                }),
                                                className: "tw-m-0 tw-text-[11.4px] tw-leading-[0.88] tw-text-newBlack/[0.6] tw-line-through",
                                                children: [
                                                    paymentLinks/* CURRENT_CURRENCY_SYMBOL */.bZ,
                                                    (0,formatPricing/* formatPriceToINR */.e)(mappedProduct === null || mappedProduct === void 0 ? void 0 : mappedProduct.price)
                                                ]
                                            }) : null
                                        ]
                                    }),
                                    !!discount && /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                        // style={{ background:config?.discountStyle !== 'text' && config?.backgroundColor,color: config?.textColor,}}
                                        className: classnames_default()("tw-m-0 tw-break-keep tw-px-[4px] tw-py-[2px] tw-text-center tw-text-[10.45px] tw-font-medium tw-leading-[1] ", "tw-bg-[#2CA861] tw-text-[#ffffff]"),
                                        children: "".concat(discount, "% OFF")
                                    })
                                ]
                            })
                        ]
                    })
                ]
            });
        case "layout4":
            if (reelItem === null || reelItem === void 0 ? void 0 : reelItem.description) {
                var descSize = (0,components_utils/* getMappedproductsTextSize */.Im)(!isMobile ? cardFrameConfig === null || cardFrameConfig === void 0 ? void 0 : cardFrameConfig.descriptionSize : cardFrameConfig === null || cardFrameConfig === void 0 ? void 0 : cardFrameConfig.descriptionSizeMobile);
                var descTextAlign = (0,components_utils/* getMappedProductTextAlign */.sz)(cardFrameConfig === null || cardFrameConfig === void 0 ? void 0 : cardFrameConfig.descriptionTextAlign);
                var descThickness = (0,components_utils/* getMappedProductTextThickness */.aA)(cardFrameConfig === null || cardFrameConfig === void 0 ? void 0 : cardFrameConfig.descriptionThicness);
                var descCasing = (0,components_utils/* getMappedProductCasing */.TI)(cardFrameConfig === null || cardFrameConfig === void 0 ? void 0 : cardFrameConfig.descriptionTextCase);
                return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "tw-mt-[16px] tw-bg-[#FFFFFF]",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                        className: classnames_default()("tw-m-0 tw-w-full", addPadding && (isMobile ? "tw-px-[10px] tw-pb-[18px]" : "tw-px-[14px] tw-pb-[15px]")),
                        style: (0,_object_spread/* default */.Z)({
                            color: cardFrameConfig === null || cardFrameConfig === void 0 ? void 0 : cardFrameConfig.descriptionColor
                        }, descSize, descTextAlign, descThickness, descCasing),
                        children: reelItem === null || reelItem === void 0 ? void 0 : reelItem.description
                    })
                });
            } else return null;
        default:
            return null;
    }
}

// EXTERNAL MODULE: ./src/components/DesignSystem/Widgets2.0/Carousel/components/Arrows/index.tsx + 1 modules
var Arrows = __webpack_require__(1523);
// EXTERNAL MODULE: ./node_modules/@mui/material/Modal/Modal.js + 4 modules
var Modal = __webpack_require__(96664);
// EXTERNAL MODULE: ./src/components/DesignSystem/Widgets2.0/ListPresentation/hooks/useDisableScroll.ts
var useDisableScroll = __webpack_require__(61551);
;// CONCATENATED MODULE: ./src/components/DesignSystem/Widgets2.0/ListPresentation/hooks/useDisableRootDoc.ts

function useDisableRootDoc(param) {
    var scrollRef = param.scrollRef, openModal = param.openModal, isMobile = param.isMobile, setScreenHeight = param.setScreenHeight, _disableDoc = param.disableDoc, disableDoc = _disableDoc === void 0 ? false : _disableDoc;
    (0,react.useEffect)(function() {
        if (isMobile) {
            setScreenHeight(window.innerHeight);
            var htmlElement = document.getElementsByTagName("html")[0];
            var bodyElement = document.getElementsByTagName("body")[0];
            var onResize = function() {
                setScreenHeight(window.innerHeight);
            };
            var modifyHtmlCustomStyles = function(addCustomStyles) {
                if (!htmlElement || !bodyElement) return;
                if (!addCustomStyles) {
                    htmlElement.style.overflowY = "";
                    htmlElement.style.position = "";
                    htmlElement.style.width = "";
                    htmlElement.style.height = "";
                    htmlElement.style.overscrollBehaviorY = "";
                    bodyElement.style.overflowY = "";
                    bodyElement.style.width = "";
                    bodyElement.style.overscrollBehaviorY = "";
                    bodyElement.style.height = "";
                } else {
                    htmlElement.style.overflowY = "hidden";
                    htmlElement.style.position = "fixed";
                    htmlElement.style.width = "100%";
                    htmlElement.style.overscrollBehaviorY = "none";
                    htmlElement.style.height = "100%";
                    htmlElement.style.maxHeight = "100%";
                    bodyElement.style.overflowY = "hidden";
                    bodyElement.style.width = "100%";
                    bodyElement.style.overscrollBehaviorY = "none";
                    bodyElement.style.height = "100%";
                    bodyElement.style.maxHeight = "100%";
                }
            };
            if (openModal) {
                disableDoc && modifyHtmlCustomStyles(true);
                window.addEventListener("resize", onResize);
            }
            if (!openModal) {
                disableDoc && modifyHtmlCustomStyles(false);
                window.removeEventListener("resize", onResize);
            }
            return function() {
                disableDoc && modifyHtmlCustomStyles(false);
            };
        }
    }, [
        scrollRef,
        openModal,
        isMobile
    ]);
    return null;
}

// EXTERNAL MODULE: ./src/components/DesignSystem/Widgets2.0/ProductCard/utils.tsx + 1 modules
var ProductCard_utils = __webpack_require__(81241);
;// CONCATENATED MODULE: ./src/components/DesignSystem/Widgets2.0/ListPresentation/components/Reels/Reels.tsx







// import { getReelCardConfigs } from '../utils';









/**
 * Notes: 1. Scroll to selected reel is done from video reel component, which calculates the positioning & scrolls the
 *            reel to the center
 * 2. In Desktop, padding is put in scroll container horizontally to put the first & last videos at the center
 * */ // to hit when scroll has ended
var scrollTrackTimer = null;
var currentFocusedReelIndex = 0;
function Reels(param) {
    var cardFrameConfig = param.cardFrameConfig, oneGridCellGeometry = param.oneGridCellGeometry, listPresentationConfig = param.listPresentationConfig, isBuilder = param.isBuilder, isMobile = param.isMobile, featuredReelConfigs = param.featuredReelConfigs, carouselIndicatorConfigs = param.carouselIndicatorConfigs;
    var onArrowSlideClick = function onArrowSlideClick(direction) {
        setCurrentFocusedReel(function(idx) {
            return idx === (reels === null || reels === void 0 ? void 0 : reels.length) - 1 && direction === "to-right" || idx === 0 && direction === "to-left" ? idx : direction === "to-right" ? idx + 1 : idx - 1;
        });
    };
    var _RenderReelsModalBody = // For Modal
    function _RenderReelsModalBody() {
        return /*#__PURE__*/ (0,jsx_runtime.jsxs)(ReelsViewportWrapper, {
            isMobile: isMobile,
            mobileHeight: screenHeight,
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: classnames_default()("tw-fixed tw-z-[10000] tw-mx-auto tw-flex tw-w-full tw-max-w-[1400px] tw-justify-end", isMobile ? "tw-right-[12px] tw-top-[12px]" : "tw-right-[36px] tw-top-[36px]"),
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        onClick: handleModalClose,
                        className: classnames_default()("ic-cross-bg-black-lg wb-sprite  tw-rounded-3xl tw-shadow-[0px_4px_4px_#00000040]")
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Arrows/* ArrowCouple */.l, {
                    isVisible: !isMobile && (scrollRef === null || scrollRef === void 0 ? void 0 : scrollRef.scrollWidth) > (scrollRef === null || scrollRef === void 0 ? void 0 : scrollRef.clientWidth),
                    className: "tw-left-[50%] -tw-translate-x-1/2 md:tw-max-w-[1100px] md:!tw-px-[40px] lg:md:!tw-px-0" // lg:tw-max-w-[980px] xl:tw-max-w-[1080px] xxl:tw-max-w-[1180px]
                    ,
                    handlePrevClick: function() {
                        return onArrowSlideClick("to-left");
                    },
                    handleNextClick: function() {
                        return onArrowSlideClick("to-right");
                    },
                    imageProps: {
                        bgColor: "#ffffff",
                        bgOpacity: 1,
                        arrowColor: "#000000",
                        height: 48,
                        width: 48
                    }
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(ReelsListWrapper, {
                    columnGap: REEL_CONFIGS.COLUMN_GAP_DESKTOP_MODAL,
                    maxWidth: !isMobile ? "800px" : "100vw",
                    ref: setCallbackScrollRef,
                    className: "no-scrollbar",
                    onScroll: handleScroll,
                    mobileHeight: screenHeight,
                    onTouchStart: function() {
                    // if (isMobile) {
                    //   if (scrollTrackTimer) clearTimeout(scrollTrackTimer);
                    // }
                    },
                    onTouchEnd: function() {
                    // if (isMobile) {
                    //   scrollTrackTimer = setTimeout(() => {
                    //     currentFocusedReelIndex = scrollRef?.scrollTop / screenHeight;
                    //     scrollRef?.scrollTo({
                    //       top: screenHeight * Math.round(currentFocusedReelIndex),
                    //       behavior: 'instant',
                    //     });
                    //     setCurrentFocusedReel(Math.round(currentFocusedReelIndex));
                    //     clearTimeout(scrollTrackTimer);
                    //     scrollTrackTimer = null;
                    //   }, 180);
                    // }
                    },
                    children: reels.map(function(reelItem, reelIdx) {
                        var ref, ref1;
                        var isThisReelFocused = reelIdx === currentFocusedReel;
                        var cardGeometry = isThisReelFocused ? REEL_CONFIGS.FOCUSED_DIMENSIONS : REEL_CONFIGS.UNFOCUSED_DIMENSIONS;
                        return /*#__PURE__*/ (0,jsx_runtime.jsxs)(ReelItem, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, cardGeometry), {
                            mobileHeight: screenHeight,
                            borderRadius: globalStyle === null || globalStyle === void 0 ? void 0 : (ref = globalStyle.imageCards) === null || ref === void 0 ? void 0 : (ref1 = ref.style) === null || ref1 === void 0 ? void 0 : ref1.borderRadius,
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(ReelsVideoSection, {
                                    isThisReelFocused: isThisReelFocused,
                                    scrollContainerRef: scrollRef,
                                    isModalOpen: openModal,
                                    ref: videoRefs,
                                    isBuilder: isBuilder,
                                    fromModal: true,
                                    cardFrameConfig: cardFrameConfig,
                                    reelIndex: reelIdx,
                                    reelItem: reelItem,
                                    isLastReel: reelIdx === (reels === null || reels === void 0 ? void 0 : reels.length) - 1,
                                    oneGridCellGeometry: cardGeometry,
                                    customStyle: isMobile ? {
                                        width: "100%",
                                        height: "100%"
                                    } : undefined,
                                    onClick: function() {
                                        return setCurrentFocusedReel(reelIdx);
                                    },
                                    modalScrolled: modalScrolled,
                                    isMobile: isMobile,
                                    shouldMuteVideo: shouldMuteVideo,
                                    setShouldMuteVideo: setShouldMuteVideo,
                                    callback: function(param) {
                                        var currentSelectedReelIdx = param.currentSelectedReelIdx;
                                        if (typeof currentSelectedReelIdx === "number") {
                                            setCurrentFocusedReel(currentSelectedReelIdx);
                                        }
                                    }
                                }),
                                (!!isMobile || !isMobile && isThisReelFocused) && /*#__PURE__*/ (0,jsx_runtime.jsx)(ReelsMetaData, {
                                    fromModal: true,
                                    reelItem: reelItem,
                                    isMobile: isMobile,
                                    cardFrameConfig: cardFrameConfig
                                })
                            ]
                        }), reelIdx);
                    })
                })
            ]
        });
    };
    var ref = (0,WidgetDndContext/* useWidgetDndContextData */.KX)(), globalStyle = ref.widgetContextState.globalStyle;
    var reelsData = cardFrameConfig === null || cardFrameConfig === void 0 ? void 0 : cardFrameConfig.reelsData;
    var layoutName = listPresentationConfig === null || listPresentationConfig === void 0 ? void 0 : listPresentationConfig.layoutName;
    var videoRefs = (0,react.useRef)({});
    var ref1 = (0,react.useState)(null), scrollRef = ref1[0], setScrollRef = ref1[1];
    var ref2 = (0,react.useState)(false), openModal = ref2[0], setOpenModal = ref2[1];
    var ref3 = (0,react.useState)(false), modalScrolled = ref3[0], setModalScrolled = ref3[1]; // This will be toggled
    var ref4 = (0,react.useState)(0), currentFocusedReel = ref4[0], setCurrentFocusedReel = ref4[1];
    var ref5 = (0,react.useState)(0), screenHeight = ref5[0], setScreenHeight = ref5[1];
    var ref6 = (0,react.useState)(false), shouldMuteVideo = ref6[0], setShouldMuteVideo = ref6[1];
    var reels = (reelsData === null || reelsData === void 0 ? void 0 : reelsData.filter(function(reelItem) {
        return reelItem.isVisible === undefined || reelItem.isVisible;
    })) || [];
    var cardWrapperConfigs = (0,ProductCard_utils/* getCartWrapperConfigs */.Ui)(listPresentationConfig);
    (0,useDisableScroll/* default */.Z)({
        isMobile: isMobile,
        scrollRef: scrollRef
    });
    useDisableRootDoc({
        scrollRef: scrollRef,
        openModal: openModal,
        isMobile: isMobile,
        setScreenHeight: setScreenHeight
    });
    (0,react.useEffect)(function() {
        if (!openModal) {
            setCurrentFocusedReel(0);
            scrollTrackTimer = null;
            currentFocusedReelIndex = 0;
        }
        return function() {
            scrollTrackTimer = null;
            currentFocusedReelIndex = 0;
        };
    }, [
        currentFocusedReel,
        openModal
    ]);
    // useEffect(() => {
    //   if (!isMobile) {
    //     console.log('currentFocusedReelIndex:  ', currentFocusedReelIndex);
    //     setCurrentFocusedReel(Math.ceil(currentFocusedReelIndex));
    //   }
    // }, [modalScrolled]);
    var handleModalOpen = function() {
        return setOpenModal(true);
    };
    var handleModalClose = function() {
        return setOpenModal(false);
    };
    var setCallbackScrollRef = (0,react.useCallback)(function(node) {
        if (!node) return;
        setScrollRef(node);
    }, []);
    var handleScroll = function() {
        if (!isMobile) {
        // const scrollPosition = scrollRef?.scrollLeft;
        // currentFocusedReelIndex = scrollPosition / REEL_WIDTH;
        }
        // This snaps the video component on the screen vertical edges, works when touch device is used
        if (isMobile) {
            if (scrollTrackTimer) {
                clearTimeout(scrollTrackTimer);
                scrollTrackTimer = null;
            }
            currentFocusedReelIndex = (scrollRef === null || scrollRef === void 0 ? void 0 : scrollRef.scrollTop) / screenHeight;
            scrollTrackTimer = setTimeout(function() {
                scrollTrackTimer = null;
                scrollRef === null || scrollRef === void 0 ? void 0 : scrollRef.scrollTo({
                    top: screenHeight * Math.round(currentFocusedReelIndex)
                });
                setCurrentFocusedReel(Math.round(currentFocusedReelIndex));
            }, 130);
        } else {
            if (scrollTrackTimer) {
                clearTimeout(scrollTrackTimer);
                scrollTrackTimer = null;
            }
            // const intialHeadStart = window.innerWidth / 1 - 45;
            currentFocusedReelIndex = (scrollRef === null || scrollRef === void 0 ? void 0 : scrollRef.scrollLeft) / ((REEL_CONFIGS.FOCUSED_DIMENSIONS.width + REEL_CONFIGS.UNFOCUSED_DIMENSIONS.width) / 2 + 90);
            scrollTrackTimer = setTimeout(function() {
                setModalScrolled(function(v) {
                    return !v;
                });
            }, 130);
        // scrollTrackTimer = setTimeout(() => {
        //   scrollTrackTimer = null;
        //   setCurrentFocusedReel(Math.round(currentFocusedReelIndex));
        // }, 130);
        }
    };
    // Shown as in page layout, no in modal
    var calculateReelLayoutDimension = function() {
        var initialWidth = oneGridCellGeometry === null || oneGridCellGeometry === void 0 ? void 0 : oneGridCellGeometry.width;
        if (cardWrapperConfigs.isCardLayout) {
            if (cardWrapperConfigs.isFullWidth) {
                initialWidth -= 2; // remove horizontal border width
            } else {
                // remove horizontal padding
                if (isMobile) initialWidth -= 20;
                else initialWidth -= 28;
            }
        }
        return {
            width: initialWidth,
            height: oneGridCellGeometry === null || oneGridCellGeometry === void 0 ? void 0 : oneGridCellGeometry.height
        };
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            reels === null || reels === void 0 ? void 0 : reels.map(function(reelItem, reelIdx) {
                // Mobile only: As this is on layout not in modal, column is set to one
                var isThisReelFocused = reelIdx * 2 === Math.floor(carouselIndicatorConfigs.scrollPercentage / reels.length) - 2 || reelIdx + 1 === 1 && Math.floor(carouselIndicatorConfigs.scrollPercentage / reels.length) - 2 === 1 || (reelIdx + 1) * 2 + 1 === Math.floor(carouselIndicatorConfigs.scrollPercentage / reels.length);
                return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: classnames_default()("imgWrapperGlobalStyle globalImgStyleConsumer tw-relative tw-flex tw-flex-shrink-0 tw-snap-center tw-flex-col tw-overflow-hidden", cardWrapperConfigs.isCardLayout && "tw-border-[1px] tw-border-solid", cardWrapperConfigs.isCardLayout && !cardWrapperConfigs.isFullWidth && (isMobile ? "tw-px-[10px] tw-py-[10px]" : "tw-px-[14px] tw-py-[14px]"), !isMobile && (cardFrameConfig === null || cardFrameConfig === void 0 ? void 0 : cardFrameConfig.hoverType) === "zoomInCard" && (ContentAnimationStyles_module_default())[(0,CardFrameCollection_utils/* getCurrentClass */.WR)(cardFrameConfig === null || cardFrameConfig === void 0 ? void 0 : cardFrameConfig.hoverType)], featuredReelConfigs.expandFocusedReel && isMobile && isThisReelFocused && "tw-scale-[1.1] tw-duration-500"),
                    style: {
                        width: "".concat(oneGridCellGeometry === null || oneGridCellGeometry === void 0 ? void 0 : oneGridCellGeometry.width, "px"),
                        borderColor: listPresentationConfig === null || listPresentationConfig === void 0 ? void 0 : listPresentationConfig.borderColor
                    },
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(ReelsVideoSection, {
                            ref: videoRefs,
                            isThisReelFocused: isThisReelFocused,
                            isBuilder: isBuilder,
                            reelItem: reelItem,
                            isMobile: isMobile,
                            isLastReel: reelItem === (reels === null || reels === void 0 ? void 0 : reels.length) - 1,
                            reelIndex: reelIdx,
                            isModalOpen: openModal,
                            cardFrameConfig: cardFrameConfig,
                            isMobileFocusPlayEnabled: featuredReelConfigs.expandFocusedReel,
                            oneGridCellGeometry: calculateReelLayoutDimension(),
                            onClick: function() {
                                setCurrentFocusedReel(reelIdx);
                                handleModalOpen();
                            }
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(ReelsMetaData, {
                            reelItem: reelItem,
                            isMobile: isMobile,
                            cardFrameConfig: cardFrameConfig,
                            layoutName: layoutName,
                            addPadding: cardWrapperConfigs.isCardLayout && cardWrapperConfigs.isFullWidth,
                            listPresentationConfig: listPresentationConfig
                        })
                    ]
                }, reelIdx);
            }),
            !isMobile ? /*#__PURE__*/ (0,jsx_runtime.jsx)(Modal/* default */.Z, {
                open: openModal,
                onClose: handleModalClose,
                "aria-labelledby": "modal-modal-title",
                "aria-describedby": "modal-modal-description",
                children: _RenderReelsModalBody()
            }) : openModal && _RenderReelsModalBody()
        ]
    });
}

;// CONCATENATED MODULE: ./src/components/DesignSystem/Widgets2.0/ListPresentation/components/Reels/index.ts



/***/ }),

/***/ 61551:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ useDisableScroll; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);

function useDisableScroll(param) {
    var _isMobile = param.isMobile, isMobile = _isMobile === void 0 ? false : _isMobile, scrollRef = param.scrollRef, _disableScroll = param.disableScroll, disableScroll = _disableScroll === void 0 ? true : _disableScroll;
    (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(function() {
        if (!isMobile && scrollRef && disableScroll) {
            var scrollLock = function(event) {
                event.preventDefault();
                event.stopPropagation();
            };
            scrollRef.addEventListener("wheel", scrollLock);
            return function() {
                scrollRef.addEventListener("wheel", scrollLock);
            };
        }
    }, [
        scrollRef
    ]);
    return null;
}


/***/ }),

/***/ 54065:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "e": function() { return /* binding */ formatPriceToINR; }
/* harmony export */ });
/* harmony import */ var _checkRenderEnv__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(6337);

var formatPriceToINR = function(price) {
    var ref;
    if (!price) return price;
    if (_checkRenderEnv__WEBPACK_IMPORTED_MODULE_0__/* .IS_SERVER */ .W6) return price;
    return ((ref = price.toLocaleString) === null || ref === void 0 ? void 0 : ref.call(price, "en-IN")) || price;
};


/***/ }),

/***/ 36508:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"widgetContentFadeInWrapper":"ContentButtonAnimationStyle_widgetContentFadeInWrapper__gzPMJ","fadeIn":"ContentButtonAnimationStyle_fadeIn__Mx5Ue","widgetContentFadeInZoomInWrapper":"ContentButtonAnimationStyle_widgetContentFadeInZoomInWrapper__9exDB","fadeInZoomIn":"ContentButtonAnimationStyle_fadeInZoomIn__FGJ6r","widgetContentMoveDownWrapper":"ContentButtonAnimationStyle_widgetContentMoveDownWrapper__EWZJt","moveDown":"ContentButtonAnimationStyle_moveDown__HotCW","builderSelectorDemo":"ContentButtonAnimationStyle_builderSelectorDemo__P7Dit","demoMoveDown":"ContentButtonAnimationStyle_demoMoveDown__VsgIP","widgetContentMoveUpWrapper":"ContentButtonAnimationStyle_widgetContentMoveUpWrapper__q4jnq","moveUp":"ContentButtonAnimationStyle_moveUp__JqBuF","demoMoveUp":"ContentButtonAnimationStyle_demoMoveUp__f_z3_","widgetContentSlideLeftWrapper":"ContentButtonAnimationStyle_widgetContentSlideLeftWrapper__C_WGJ","moveLeft":"ContentButtonAnimationStyle_moveLeft__wtumW","demoMoveLeft":"ContentButtonAnimationStyle_demoMoveLeft__XAysw","widgetContentSlideRightWrapper":"ContentButtonAnimationStyle_widgetContentSlideRightWrapper__Ael_0","moveRight":"ContentButtonAnimationStyle_moveRight__NWc9p","demoMoveRight":"ContentButtonAnimationStyle_demoMoveRight__kmTdf","imageZoomIn":"ContentButtonAnimationStyle_imageZoomIn__zXH0u","imageZoomOut":"ContentButtonAnimationStyle_imageZoomOut__ywFAu","zoomInOnHover":"ContentButtonAnimationStyle_zoomInOnHover__wpSXv","ambient":"ContentButtonAnimationStyle_ambient__lq2Vz","animationAmbient":"ContentButtonAnimationStyle_animationAmbient__Mp7Dt"};

/***/ })

}]);